import * as React from 'react';
/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the [[useSelectRange]] hook.
 */
export var SelectRangeContext = React.createContext(undefined);
//# sourceMappingURL=SelectRangeContext.js.map